const initCertLightbox = () => {
  const galleries = document.querySelectorAll("[data-cert-lightbox]");
  if (!galleries.length) return;

  const dialog = document.createElement("dialog");
  dialog.className = "cert-lightbox";
  dialog.setAttribute("aria-label", "賞状拡大表示");
  dialog.innerHTML = `
    <button type="button" class="cert-lightbox__close" aria-label="閉じる">&times;</button>
    <figure class="cert-lightbox__figure">
      <img class="cert-lightbox__img" src="" alt="" />
    </figure>
  `;
  document.body.appendChild(dialog);

  const img = dialog.querySelector(".cert-lightbox__img");
  const closeBtn = dialog.querySelector(".cert-lightbox__close");

  const open = (src, alt) => {
    img.src = src;
    img.alt = alt;
    dialog.showModal();
    document.body.classList.add("is-cert-lightbox-open");
  };

  const close = () => {
    dialog.close();
    document.body.classList.remove("is-cert-lightbox-open");
    img.src = "";
  };

  galleries.forEach((gallery) => {
    const buttons = [...gallery.querySelectorAll("[data-cert-src]")];
    buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        open(button.dataset.certSrc, button.dataset.certAlt || "");
      });
    });
  });

  closeBtn.addEventListener("click", close);

  dialog.addEventListener("click", (event) => {
    const rect = dialog.getBoundingClientRect();
    const isBackdrop =
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom;
    if (isBackdrop) close();
  });

  dialog.addEventListener("cancel", () => {
    document.body.classList.remove("is-cert-lightbox-open");
    img.src = "";
  });
};

document.addEventListener("DOMContentLoaded", initCertLightbox);
